/* funnel.js - how far a stranger gets (plan Phase 8, Xav 2026-10-12).
 *
 * Signed-out pages only (base.html). Four steps, each sent once per tab
 * session to /api/ux/step (routes/funnel.py), which keeps a daily count and
 * nothing else - no id, no cookie:
 *   home        the homepage was seen
 *   demo_open   a demo board opened  (src = where they came from)
 *   demo_30s    ...and stayed visible for 30 seconds
 *   start_free  a Start free / sign-up link was pressed (src = which page)
 * A link shared as liveslates.com/?via=reddit tags the tab: every step it then
 * reaches carries the channel (2026-10-20), and the tag leaves the address bar
 * so a visitor who shares the page on does not pass ours along.
 * A beacon only fires where JavaScript runs, which is most of the bot filter;
 * the server drops bot user-agents and signed-in visitors on top.
 */
(function () {
  'use strict';
  var path = location.pathname;
  var page = /^\/(us|uk)?\/?$/.test(path) ? 'home'
           : path.indexOf('/demo/') === 0 ? 'demo'
           : path === '/pro' ? 'pro' : 'other';

  function once(key) {
    try {
      if (sessionStorage.getItem('ls_fn_' + key)) return false;
      sessionStorage.setItem('ls_fn_' + key, '1');
    } catch (_) { /* storage blocked: count anyway */ }
    return true;
  }
  var via = '';
  try {
    var q = new URLSearchParams(location.search).get('via');
    if (q && /^[a-z0-9][a-z0-9-]{0,31}$/i.test(q)) sessionStorage.setItem('ls_fn_via', q.toLowerCase());
    via = sessionStorage.getItem('ls_fn_via') || '';
    if (q != null && history.replaceState) {
      var u = new URL(location.href); u.searchParams.delete('via');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    }
  } catch (_) { /* no storage: the channel is simply not known */ }

  function hit(step, src) {
    if (navigator.webdriver || !once(step)) return;
    var body = JSON.stringify({ step: step, src: src, via: via });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon('/api/ux/step', new Blob([body], { type: 'application/json' }))) return;
    } catch (_) {}
    try { fetch('/api/ux/step', { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'application/json' } }); } catch (_) {}
  }
  function cameFrom() {
    var r = document.referrer;
    if (!r) return 'direct';
    try {
      var u = new URL(r);
      if (u.host !== location.host) return 'external';
      return /^\/(us|uk)?\/?$/.test(u.pathname) ? 'home' : 'other';
    } catch (_) { return 'other'; }
  }

  if (page === 'home') hit('home', 'home');
  if (page === 'demo') {
    var src = cameFrom();
    hit('demo_open', src);
    // 30 seconds of the tab actually being looked at, not 30 seconds open in
    // a background tab.
    var seen = 0, last = Date.now();
    var t = setInterval(function () {
      var now = Date.now();
      if (document.visibilityState === 'visible') seen += now - last;
      last = now;
      if (seen >= 30000) { clearInterval(t); hit('demo_30s', src); }
    }, 1000);
  }
  document.addEventListener('click', function (e) {
    // a sign-up link, or a front-door Start free (it opens /slates since
    // 2026-10-20 - watching needs no account - and is marked data-ls-start)
    var a = e.target && e.target.closest ? e.target.closest('a[href^="/signup"], a[data-ls-start]') : null;
    if (a) hit('start_free', page);
  }, true);
})();
